export default __webpack_public_path__ + "static/media/cross.6eb7fcfd.svg";